import { render, staticRenderFns } from "./EmpresaWhatsapp.vue?vue&type=template&id=387eae25&scoped=true"
import script from "./EmpresaWhatsapp.vue?vue&type=script&lang=js"
export * from "./EmpresaWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387eae25",
  null
  
)

export default component.exports